import React, { FC } from 'react';
import classNames from 'classnames';

import { Toggle, ToggleProps, ToggleSize } from 'app/design-system/components/Toggle';

import styles from './InitialToggle.module.scss';

// ---

type InitialToggleProps = {
  title: string;
  size?: ToggleSize;
  className?: string;
  'data-test'?: string;
  dataGaEvent?: string;
} & Pick<ToggleProps, 'active' | 'onChange' | 'disabled'>;

const InitialToggle: FC<InitialToggleProps> = ({
  title,
  active,
  onChange,
  size = ToggleSize.SMALL,
  className,
  disabled,
  dataGaEvent,
  ...props
}) => {
  const _className = classNames(styles.label, {
    [styles.disabled]: disabled,
  }, className);

  return (
    <label className={_className}
           data-test={classNames(props['data-test'], 'toggle-container')}>
      <Toggle active={active}
              disabled={disabled}
              size={size}
              data-ga-event={dataGaEvent}
              data-ga-event-value={active ? 'On' : 'Off'}
              onChange={onChange} />
      <span className={styles.title}
            data-test="toggle-title">
        {title}
      </span>
    </label>
  );
};

export default InitialToggle;
